import { Component, Prop, h } from '@stencil/core';
import chat from '../../assets/header/chat_bubble.svg';
import Cookies from 'js-cookie';

@Component({
  tag: 'customer-chat',
  styleUrl: 'customer-chat.scss',
})
export class CustomerChat {
  @Prop() chatFlavor: 'default' | 'simple' = 'default';

  render() {
    const hvprCookie = Cookies.get('ttarp_override');
    const liveEngageId = hvprCookie === '855-792-1402' ? 'LP_DIV_2023_1645056394123' : 'LP_DIV_2023_6687889599';
    if (this.chatFlavor == 'simple') {
      return (
        <div class="ghf-customerChat--simple">
          <div class="img" title="Speech Bubble with Checkmark" />
          <div>
            <span class="ghf-customerChat-text">Chat With A Real Person</span>
            <span id="LP_DIV_RB_6687889599" class="sb-LiveEngage-chat ghf-customerChat-liveEngage--desktop">
              <p class="ghf-customerChat-storeText" aria-hidden="true">
                Chat Now
              </p>
            </span>
            <span id="LP_DIV_RB_1501165477970" class="sb-LiveEngage-chat ghf-customerChat-liveEngage--mobile">
              <p class="ghf-customerChat-storeText" aria-hidden="true">
                Chat With a Real Person
              </p>
            </span>
          </div>
          <live-engage-init-script />
        </div>
      );
    }
    return (
      <div class="ghf-customerChat--default--desktop">
        <img src={chat} alt="chat bubble" />
        <span id={liveEngageId} class="sb-LiveEngage-chat">
          <span class="ghf-customerChat-text">Chat with a real person</span>
        </span>
        <live-engage-init-script />
      </div>
    );
  }
}
